import { useAuth } from '../context/AuthContext';

/**
 * Convenience hook for role checks.
 * Returns helpers derived from the current user's org membership.
 *
 * Usage:
 *   const { hasRole, isAdmin, isSeat, isBilling, isIT, orgMember, org } = useOrgRole();
 */
export default function useOrgRole() {
  const { orgMember, org, isSuperAdmin } = useAuth() || {};
  const roles = orgMember?.roles || [];

  return {
    roles,
    isSuperAdmin: !!isSuperAdmin,
    hasRole:   (role) => !!isSuperAdmin || roles.includes(role),
    isAdmin:   !!isSuperAdmin || roles.includes('admin'),
    isBilling: !!isSuperAdmin || roles.includes('billing'),
    isIT:      !!isSuperAdmin || roles.includes('it'),
    isSeat:    !!isSuperAdmin || roles.includes('seat'),
    orgMember,
    org,
  };
}
